import Cookies from 'js-cookie'
import { useContext } from 'react'
import { useState, useEffect } from 'react'
import { showModal, pdfToModal } from '../../../components/modal'
import { AuthContext } from '../../../contexts/auth'
import { downloadContrato } from '../../../services/api'

const Contract = ({ contract }) => {
	const [pdf, setPDF] = useState()

	useEffect(() => {
		;(async () => {
			const response = await downloadContrato(contract.project_id)
			const blob = new Blob([response.data], {
				type: 'application/pdf',
			})
			const newUrl = window.URL.createObjectURL(blob)
			setPDF(newUrl)
		})()
	}, [])

	const handlerContract = () => {
		pdfToModal(pdf)
		showModal()
	}

	return (
		<div className="contractField">
			<div className="textField">
				<label className="label">Nome do Caso:</label>
				<span className="text">{contract.project_name}</span>
			</div>
			<div className="textField">
				<label className="label">Data de criação do contrato:</label>
				<span className="text">{contract.signature_date.slice(0, 10).split('-').reverse().join('/')}</span>
			</div>

			{pdf ? (
				<div className="textField pdfField" onClick={handlerContract}>
					<a>
						<label className="label">Visualizar/Baixar PDF:</label>
						<span className="material-symbols-outlined text">picture_as_pdf</span>
					</a>
				</div>
			) : (
				<div>Carregando PDF</div>
			)}

			<div className="textField">
				<span className="text">{contract.status === 1 ? '' : '*Falta assinatura'}</span>
			</div>
			<div className="textField objeto">
				<span className="label objetoTitle">Objeto: </span>
				<span className="text">{contract.demand_object}</span>
			</div>
		</div>
	)
}

export default Contract
